import axios from 'axios';
import { toast } from 'react-toastify';

// Configurable base URL. Defaults to a relative path so production keeps
// working behind the Apache reverse proxy at graduates.katinetti.ac.ke.
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

console.log('🔧 API Configuration:', {
  baseURL: API_BASE_URL,
  environment: process.env.NODE_ENV
});

// No global Content-Type: axios sets `application/json` automatically for plain
// objects, and must be free to set `multipart/form-data; boundary=…` for
// FormData uploads. Forcing JSON here made every file upload arrive as a
// multipart body with a JSON header, which the API rejected with a 500
// ("… is not valid JSON") — that is what broke image uploads.
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 180000,
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log(`📤 API Request: ${config.method.toUpperCase()} ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log(`📥 API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('Response Error:', error);

    if (error.code === 'ERR_NETWORK') {
      toast.error('Cannot connect to server. Please try again.');
    } else if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      toast.error('Session expired. Please login again.');
    } else if (error.response?.status === 403) {
      toast.error('You do not have permission to perform this action');
    } else if (error.response?.status === 500) {
      toast.error('Server error. Please try again later.');
    }

    return Promise.reject(error);
  }
);

export default api;
